import React from 'react';
import ModalVideo from 'react-modal-video';

import Popup from '../../Popup';
import styles from './welcomePopUps.scss';

class CreateDrawsWelcomePopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            videoIsOpen: false,
            currentVideoId: '',
        };
    }

    render() {
        const {
            onCloseClick,
            onCtaClick,
        } = this.props;

        return (
            <Popup
                className={`popup-md`}
                popUpClassName={`${styles.welcomePopUp}`}
                onCloseClick={onCloseClick}
                config={{
                    noPadding: true,
                    fullScreen: false,
                    topGradient: false,
                    scrollable: false,
                }}
            >
                <div className={`${styles.section} pt0`}>
                    <h4>
                        Create your draws!
                        <span className="d-block">
                            Match players up based on UTR Rating
                        </span>
                    </h4>
                </div>
                <div className={`${styles.section} pt0`}>
                    <p>
                        Create level-based play using different draw formats for singles and doubles. Schedule matches and post scores from results that count towards players&apos; ratings.
                    </p>
                    <div className={`${styles.tip}`}>
                        <span
                            className={`cursor-pointer`}
                            onClick={() => {
                                this.setState({
                                    videoIsOpen: true,
                                    currentVideoId: 'yGQPc6MJKM0',
                                });
                            }}
                        >
                            <i className="fas fa-play" /><span>Watch intro video on creating draws</span>
                        </span>
                    </div>
                    <div className="bb" />
                    <button
                        type="button"
                        className="btn btn-primary btn-xl btn-block text-uppercase"
                        onClick={onCtaClick}
                    >
                        Got It
                    </button>
                </div>
                <ModalVideo
                    channel="youtube"
                    isOpen={this.state.videoIsOpen}
                    videoId={this.state.currentVideoId}
                    autoplay={true}
                    onClose={() => {
                        this.setState({
                            videoIsOpen: false,
                            currentVideoId: '',
                        });
                    }}
                />
            </Popup>
        );
    }
}

export default CreateDrawsWelcomePopUp;
